export default __webpack_public_path__ + "static/Poppins-LightItalic-4a7d59f898225cc2f2e7d64dacf14720.ttf";